export const getFlowContentSize = (min: number, max: number, zoom: number) => {
  return zoom * (max - min);
};
